/**
 * Soft geolocation for Web Snap & Stash (FR-W5): best-effort capture
 * coordinates for the extraction locationHint. Resolves undefined on
 * denial, absence, or its own 5s timeout — never throws, never blocks the
 * flow. Callers OMIT the key when undefined (nil-key parity rule).
 */
import type { LocationHint } from '@stash/shared-types';

const TIMEOUT_MS = 5000;

export function getLocationHint(): Promise<LocationHint | undefined> {
  return new Promise((resolve) => {
    const geolocation = navigator.geolocation;
    if (!geolocation?.getCurrentPosition) {
      resolve(undefined);
      return;
    }
    let settled = false;
    const settle = (hint: LocationHint | undefined) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve(hint);
    };
    const timer = setTimeout(() => settle(undefined), TIMEOUT_MS);
    try {
      geolocation.getCurrentPosition(
        (position) => settle({ lat: position.coords.latitude, lng: position.coords.longitude }),
        () => settle(undefined),
        { timeout: TIMEOUT_MS, maximumAge: 60_000 },
      );
    } catch {
      settle(undefined);
    }
  });
}
